import { render, staticRenderFns } from "./ShotsDetails.vue?vue&type=template&id=9f9ccefa&scoped=true&"
import script from "./ShotsDetails.vue?vue&type=script&lang=js&"
export * from "./ShotsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShotsDetails.vue?vue&type=style&index=0&id=9f9ccefa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9ccefa",
  null
  
)

export default component.exports